module.exports = __webpack_public_path__ + "img/Septris-sprite-or-bg.ebaa1754.png";